export default __webpack_public_path__ + "static/media/armbands_of_vengeful_zeal.a8345c43.jpg";